import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b8371e26"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Send")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Receive")
const _hoisted_3 = {
  class: "col-lg-4",
  style: {"margin-bottom":"30px","margin-top":"30px"}
}
const _hoisted_4 = { class: "card card-stretch-50 shadow mb-5" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "card-title" }, "Current Balance", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Refresh ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Refreshing")
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"gray"} }, [
  /*#__PURE__*/_createElementVNode("strong", null, "AUD")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "All the changes will be lost.", -1))
const _hoisted_12 = { class: "dialog-footer" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("No, STAY")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Yes, CANCEL")
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M764.288 214.592 512 466.88 259.712 214.592a31.936 31.936 0 0 0-45.12 45.12L466.752 512 214.528 764.224a31.936 31.936 0 1 0 45.12 45.184L512 557.184l252.288 252.288a31.936 31.936 0 0 0 45.12-45.12L557.12 512.064l252.288-252.352a31.936 31.936 0 1 0-45.12-45.184z"
}, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"float":"right"} }, " How much would you like to send? ", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"right","margin-top":"10px"} }, "Estimated exchange rate:", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = { style: {"float":"right","font-size":"15px","color":"gray"} }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"right","margin-top":"10px"} }, "Your current balance is:", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_26 = { style: {"float":"right","font-size":"15px","color":"gray"} }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("AUD")
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"color":"darkred"} }, "Minimum amount 200 AUD", -1))
const _hoisted_30 = /*#__PURE__*/_createTextVNode("Next")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("Next")
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("Back")
const _hoisted_35 = /*#__PURE__*/_createTextVNode("Next")
const _hoisted_36 = { key: 2 }
const _hoisted_37 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" OR ")
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" OR ")
const _hoisted_40 = /*#__PURE__*/_createTextVNode("Back")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("Next")
const _hoisted_42 = { key: 3 }
const _hoisted_43 = {
  key: 0,
  style: {"display":"flex","justify-content":"center","margin-bottom":"15px","margin-top":"20px","width":"100%"}
}
const _hoisted_44 = { style: {"font-size":"15px","color":"#3043AC"} }
const _hoisted_45 = { style: {"font-size":"15px","color":"#3043AC"} }
const _hoisted_46 = { style: {"font-size":"15px","color":"#3043AC"} }
const _hoisted_47 = { style: {"font-size":"15px","color":"#3043AC"} }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_50 = {
  key: 1,
  style: {"display":"flex","justify-content":"center","margin-bottom":"15px","margin-top":"20px","width":"100%"}
}
const _hoisted_51 = /*#__PURE__*/_createTextVNode("Back")
const _hoisted_52 = /*#__PURE__*/_createTextVNode("Confirm and Send")
const _hoisted_53 = { key: 4 }
const _hoisted_54 = { style: {"display":"flex","justify-content":"center","margin-bottom":"15px","margin-top":"20px"} }
const _hoisted_55 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_56 = /*#__PURE__*/_createTextVNode("Done")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_result = _resolveComponent("el-result")!
  const _component_er_row = _resolveComponent("er-row")!
  const _component_el_card = _resolveComponent("el-card")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_menu, {
      "default-active": _ctx.activeIndex,
      class: "el-menu-demo",
      mode: "horizontal",
      ellipsis: false,
      onSelect: _ctx.handleSelect
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_menu_item, { index: "1" }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "2" }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["default-active", "onSelect"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          (!_ctx.refreshPending)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "text",
                style: {"font-size":"16px"},
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refreshBalance()))
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.refreshPending)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "text",
                style: {"font-size":"16px"},
                loading: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _withDirectives((_openBlock(), _createElementBlock("h1", null, [
            _createTextVNode("AU$ " + _toDisplayString(_ctx.getAccountBalanceRef ? (_ctx.getAccountBalanceRef[0] ? _ctx.getAccountBalanceRef[0].cleared.toFixed(2) : '') : ''), 1)
          ])), [
            [_directive_loading, _ctx.refreshPending]
          ])
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialogVisible) = $event)),
      title: "Cancel sending the payment",
      width: "30%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_12, [
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialogVisible = false))
          }, {
            default: _withCtx(() => [
              _hoisted_13
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.confirmCancelSend
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_11
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.showSend)
      ? (_openBlock(), _createBlock(_component_el_card, {
          key: 0,
          class: "box-card"
        }, {
          default: _withCtx(() => [
            (!_ctx.sendFundSuccess)
              ? (_openBlock(), _createElementBlock("svg", {
                  key: 0,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cancelSend())),
                  style: {"width":"30px","height":"30px","float":"right"},
                  viewBox: "0 0 1024 1024",
                  xmlns: "http://www.w3.org/2000/svg",
                  "data-v-029747aa": ""
                }, _hoisted_16))
              : _createCommentVNode("", true),
            _createVNode(_component_el_steps, {
              active: _ctx.stepIndex,
              "finish-status": "success",
              style: {"margin-top":"15px","margin-bottom":"25px","background-color":"white"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_step, {
                  title: "Step 1 of 4",
                  description: "Transfer amount"
                }),
                _createVNode(_component_el_step, {
                  title: "Step 2 of 4",
                  description: "Choose a sender/sub-client"
                }),
                _createVNode(_component_el_step, {
                  title: "Step 3 of 4",
                  description: "Choose a recipient"
                }),
                _createVNode(_component_el_step, {
                  title: "Step 4 of 4",
                  description: "Verify details"
                })
              ]),
              _: 1
            }, 8, ["active"]),
            _createElementVNode("div", _hoisted_17, [
              (_ctx.stepIndex === 0)
                ? _withDirectives((_openBlock(), _createBlock(_component_el_form, {
                    key: 0,
                    ref: "stepOneFormRef",
                    model: _ctx.stepOneForm,
                    "label-width": "150px",
                    style: {"width":"1000px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 4 }, {
                            default: _withCtx(() => [
                              _hoisted_18,
                              _hoisted_19,
                              _hoisted_20,
                              _hoisted_21,
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("strong", null, "1 AUD = " + _toDisplayString(_ctx.quoteRef ? _ctx.quoteRef.bid : '') + " " + _toDisplayString(_ctx.stepOneForm.receivedCurrency ? _ctx.stepOneForm.receivedCurrency : '-'), 1)
                              ]),
                              _hoisted_23,
                              _hoisted_24,
                              _hoisted_25,
                              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_26, [
                                _createElementVNode("strong", null, " AUD " + _toDisplayString(_ctx.getAccountBalanceRef ? (_ctx.getAccountBalanceRef[0] ? _ctx.getAccountBalanceRef[0].cleared : '') : ''), 1)
                              ])), [
                                [_directive_loading, _ctx.refreshPending]
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 20 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, {
                                label: "You send",
                                required: "",
                                prop: "sendAmount"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.stepOneForm.sendAmount,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.stepOneForm.sendAmount) = $event)),
                                    type: "number",
                                    style: {"width":"400px"},
                                    precision: 3,
                                    controls: false,
                                    onChange: _ctx.handleSendAmountChange
                                  }, {
                                    prepend: _withCtx(() => [
                                      _hoisted_27
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "onChange"]),
                                  _hoisted_28,
                                  _hoisted_29
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_form_item, {
                                label: "They receive",
                                required: "",
                                prop: "receivedAmount"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: _ctx.stepOneForm.receivedAmount,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.stepOneForm.receivedAmount) = $event)),
                                    style: {"width":"400px"},
                                    type: "number",
                                    precision: 3,
                                    step: 0.1,
                                    controls: false,
                                    class: "input-with-select",
                                    onChange: _ctx.handleReceivedAmountChange
                                  }, {
                                    prepend: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        modelValue: _ctx.stepOneForm.receivedCurrency,
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.stepOneForm.receivedCurrency) = $event)),
                                        placeholder: "Currency",
                                        onChange: _ctx.handleSelectCurrency,
                                        style: {"width":"115px","background-color":"transparent"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_option, {
                                            label: "USD",
                                            value: "USD"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "NZD",
                                            value: "NZD"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "EUR",
                                            value: "EUR"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "GBP",
                                            value: "GBP"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "HKD",
                                            value: "HKD"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "SGD",
                                            value: "SGD"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "AED",
                                            value: "AED"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "CAD",
                                            value: "CAD"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "CHF",
                                            value: "CHF"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "CNY",
                                            value: "CNY"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "DKK",
                                            value: "DKK"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "ILS",
                                            value: "ILS"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "INR",
                                            value: "INR"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "JPY",
                                            value: "JPY"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "MXN",
                                            value: "MXN"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "MYR",
                                            value: "MYR"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "NOK",
                                            value: "NOK"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "PHP",
                                            value: "PHP"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "SEK",
                                            value: "SEK"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "THB",
                                            value: "THB"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "TRY",
                                            value: "TRY"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "ZAR",
                                            value: "ZAR"
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue", "onChange"])
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "step", "onChange"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 4 }),
                          _createVNode(_component_el_col, { span: 20 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  (_ctx.stepOneForm.sendAmount < 200)
                                    ? (_openBlock(), _createBlock(_component_el_button, {
                                        key: 0,
                                        type: "primary",
                                        onClick: _ctx.onToStepTwo,
                                        disabled: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_30
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"]))
                                    : _createCommentVNode("", true),
                                  (_ctx.stepOneForm.sendAmount >=200)
                                    ? (_openBlock(), _createBlock(_component_el_button, {
                                        key: 1,
                                        type: "primary",
                                        onClick: _ctx.onToStepTwo
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_31
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"])), [
                    [_directive_loading, _ctx.loadingRef]
                  ])
                : _createCommentVNode("", true)
            ]),
            (_ctx.stepIndex === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _withDirectives((_openBlock(), _createBlock(_component_el_form, {
                      ref: "stepThirdFormRef",
                      model: _ctx.stepThirdForm,
                      "label-width": "250px",
                      "label-position": "left",
                      style: {"width":"700px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "Select a recipient",
                          required: "",
                          prop: "recipientId"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.stepThirdForm.recipientId,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.stepThirdForm.recipientId) = $event)),
                              placeholder: "please select a recipient",
                              style: {"width":"400px"},
                              filterable: ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getRecipientsRef.filter(it => it.currency === _ctx.stepOneForm.receivedCurrency), (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item,
                                    label: (item.firstName? ('Individual: '+item.firstName + ' ' + item.lastName) : 'Entity: ' + item.companyName) + '-'+item.country +'_'+item.currency ,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "What's the payment reason?",
                          required: "",
                          prop: "paymentReason"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.stepThirdForm.paymentReason,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.stepThirdForm.paymentReason) = $event)),
                              placeholder: "please select a payment reason",
                              style: {"width":"400px"},
                              filterable: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  label: "Family",
                                  value: "FAMILY"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Business",
                                  value: "BUSINESS"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Travel",
                                  value: "TRAVEL"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Property",
                                  value: "PROPERTY"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Investment",
                                  value: "INVESTMENT"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Study",
                                  value: "STUDY"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Living expenses",
                                  value: "LIVING_EXPENSES"
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "What's the source of funds?",
                          required: "",
                          prop: "sourceOfFund"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.stepThirdForm.sourceOfFund,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.stepThirdForm.sourceOfFund) = $event)),
                              placeholder: "please select a source of funds",
                              style: {"width":"400px"},
                              filterable: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  label: "Salary",
                                  value: "SALARY"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Credit card",
                                  value: "CREDIT_CARD"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Business funds",
                                  value: "BUSINESS_FUNDS"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Rental income",
                                  value: "RENTAL_INCOME"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Sale of assets",
                                  value: "ASSETS_SALE"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Payment from 3rd party",
                                  value: "THIRD_PARTY_PAYMENT"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Savings",
                                  value: "SAVINGS"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Gift / Loan from family or friends",
                                  value: "FAMILY_OR_FRIENDS"
                                }),
                                _createVNode(_component_el_option, {
                                  label: "Inheritance",
                                  value: "INHERITANCE"
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "Payment reference",
                          prop: "paymentReference"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.stepThirdForm.paymentReference,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.stepThirdForm.paymentReference) = $event)),
                              rows: 2,
                              type: "textarea",
                              style: {"width":"100%"},
                              placeholder: "Optional data sent to the recipient's financial institution"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.stepIndex = 1))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_34
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _ctx.onToStepFour
                            }, {
                              default: _withCtx(() => [
                                _hoisted_35
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model"])), [
                      [_directive_loading, _ctx.loadingRef]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.stepIndex === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _withDirectives((_openBlock(), _createBlock(_component_el_form, {
                      ref: "stepTwoFormRef",
                      model: _ctx.stepTwoForm,
                      "label-width": "170px",
                      "label-position": "left",
                      style: {"width":"700px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "Select a sender",
                          prop: "senderId"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.stepTwoForm.senderId,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.stepTwoForm.senderId) = $event)),
                              placeholder: "please select a sender",
                              onChange: _ctx.handleChooseSender,
                              style: {"width":"400px"},
                              filterable: ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSendersRef, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item,
                                    label: item.firstName? ('Individual-'+item.firstName + ' ' + item.lastName) : 'Entity-' + item.companyName ,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        }),
                        _hoisted_38,
                        _createVNode(_component_el_form_item, {
                          label: "Select a sub-client",
                          prop: "subclientId",
                          style: {"margin-top":"15px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.stepTwoForm.subclientId,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.stepTwoForm.subclientId) = $event)),
                              placeholder: "please select a sub-client",
                              onChange: _ctx.handleChooseSubclient,
                              style: {"width":"400px"},
                              filterable: ""
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSubclientsRef.filter(it => it.status === 'ACTIVE' ), (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item,
                                    label: item.clientType === 'INDIVIDUAL'? ('Individual-'+item.fullName ) : 'Entity-' + item.legalName ,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        }),
                        _hoisted_39,
                        _createVNode(_component_el_form_item, {
                          label: "CFG As Sender",
                          prop: "cfgIsSender",
                          style: {"margin-top":"15px"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_checkbox, {
                              modelValue: _ctx.cfgSenderValue,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.cfgSenderValue) = $event)),
                              onChange: _ctx.handleChooseCFG,
                              label: "",
                              size: "large"
                            }, null, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, { style: {"margin-top":"10px"} }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.stepIndex = 0))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_40
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _ctx.onToStepThree
                            }, {
                              default: _withCtx(() => [
                                _hoisted_41
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model"])), [
                      [_directive_loading, _ctx.loadingRef]
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.stepIndex === 3)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_42, [
                  (!_ctx.sendFundSuccess)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                        _createVNode(_component_el_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 24 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_descriptions, { title: "Please confirm the details of this transfer" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_descriptions_item, { label: "Amount you're sending" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_44, [
                                          _createElementVNode("strong", null, "AUD " + _toDisplayString(_ctx.stepOneForm.sendAmount), 1)
                                        ])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_descriptions_item, { label: "Amount they'll receive" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_45, [
                                          _createElementVNode("strong", null, _toDisplayString(_ctx.stepOneForm.receivedCurrency + ' ' + _ctx.stepOneForm.receivedAmount), 1)
                                        ])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_descriptions_item, { label: "Final exchange rate" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_46, [
                                          _createElementVNode("strong", null, "1 AUD = " + _toDisplayString(_ctx.quoteRef ? _ctx.quoteRef.bid : '') + " " + _toDisplayString(_ctx.stepOneForm.receivedCurrency ? _ctx.stepOneForm.receivedCurrency : '-'), 1)
                                        ])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_el_descriptions_item, { label: "Who you're sending to" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_47, [
                                          _createElementVNode("strong", null, [
                                            _createTextVNode(_toDisplayString(_ctx.stepThirdForm.recipientId ?
                        (_ctx.getRecipientsRef.filter(it => it.id === _ctx.stepThirdForm.recipientId)[0].firstName ?
                            'Individual: ' + _ctx.getRecipientsRef.filter(it => it.id === _ctx.stepThirdForm.recipientId)[0].firstName + ' ' + _ctx.getRecipientsRef.filter(it => it.id === _ctx.stepThirdForm.recipientId)[0].lastName
                            : 'Entity: ' + _ctx.getRecipientsRef.filter(it => it.id === _ctx.stepThirdForm.recipientId)[0].companyName) : ''), 1),
                                            _hoisted_48,
                                            _createTextVNode(_toDisplayString(_ctx.stepThirdForm.recipientId ?
                        ((_ctx.getRecipientsRef.filter(it => it.id === _ctx.stepThirdForm.recipientId)[0].accountName ? _ctx.getRecipientsRef.filter(it => it.id === _ctx.stepThirdForm.recipientId)[0].accountName : '') + ' ' + _ctx.getRecipientsRef.filter(it => it.id === _ctx.stepThirdForm.recipientId)[0].accountNo
                        ) : '') + " ", 1),
                                            _hoisted_49,
                                            _createTextVNode(" " + _toDisplayString(_ctx.stepThirdForm.recipientId ?
                        (_ctx.getRecipientsRef.filter(it => it.id === _ctx.stepThirdForm.recipientId)[0].bic ? _ctx.getRecipientsRef.filter(it => it.id === _ctx.stepThirdForm.recipientId)[0].bic : ''
                        ) : ''), 1)
                                          ])
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.sendFundSuccess)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                        _createVNode(_component_el_row, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_col, { span: 24 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.stepIndex = 2))
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_51
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  onClick: _ctx.sendFund
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_52
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])), [
                  [_directive_loading, _ctx.loadingRef]
                ])
              : _createCommentVNode("", true),
            (_ctx.stepIndex === 4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                  _createElementVNode("div", _hoisted_54, [
                    _createVNode(_component_el_result, {
                      icon: "success",
                      title: "Send Successful",
                      "sub-title": "You can review this payment ledger in your FlashFX portal"
                    }, {
                      extra: _withCtx(() => []),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createVNode(_component_er_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_col, { span: 24 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _ctx.donePayout
                            }, {
                              default: _withCtx(() => [
                                _hoisted_56
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}